// /client/src/pages/public/HomePage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Typography, Chip, Stack, CircularProgress, Card, CardContent, CardActions, Button } from '@mui/material';
import { HoverEffect } from '../../components/ui/card-hover-effect'; // We will create this file next

const HomePage = () => {
  const [projects, setProjects] = useState([]);
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [projectsRes, skillsRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/api/projects`),
          axios.get(`${process.env.REACT_APP_API_URL}/api/skills`)
        ]);
        setProjects(projectsRes.data);
        setSkills(skillsRes.data);
      } catch (error) {
        console.error("Failed to fetch public data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, []);

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>;
  }

  return (
    <Box>
      {/* Hero Section */}
      <Box sx={{ my: 4, textAlign: 'center' }}>
        <Typography variant="h2" component="h1" gutterBottom>
          Hello, I'm a Developer
        </Typography>
        <Typography variant="h5" color="text.secondary">
          Welcome to my personal portfolio.
        </Typography>
      </Box>

      {/* Skills Section */}
      <Box sx={{ my: 5 }}>
        <Typography variant="h4" component="h2" gutterBottom align="center">
          My Skills
        </Typography>
        <Stack direction="row" justifyContent="center" flexWrap="wrap" gap={1}>
          {skills.map(skill => <Chip key={skill._id} label={skill.name} variant="outlined" />)}
        </Stack>
      </Box>

      {/* Projects Section with Aceternity UI */}
      <Box sx={{ my: 5 }}>
        <Typography variant="h4" component="h2" gutterBottom align="center">
          Featured Projects
        </Typography>
        {/* We use the items prop for the Aceternity component */}
        <HoverEffect items={projects} />
      </Box>
    </Box>
  );
};

export default HomePage;